import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core'
import { provideState } from '@ngrx/store'
import { provideEffects } from '@ngrx/effects'

import { METRIC_DETAIL_FEATURE_TOKEN } from './constants/metric-detail.constants'
import { metricDetailReducer } from './store/reducers/metric-detail.reducer'
import { MetricDetailEffects } from './store/effects/metric-detail.effects'

export function provideMetricDetail(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(METRIC_DETAIL_FEATURE_TOKEN, metricDetailReducer),
    provideEffects([MetricDetailEffects])
  ])
}
